{
	"labelsRacun" :{
		"opozorilo": "S klikom na 'Izbriši' bo vaš račun deaktiviran. Po deaktivaciji ne boste morali več vstopati in uporabljati programa WingSI. ",
		"potrdiIzbris": "Ali ste prepričani, da želite izbrisati/deaktivirati vaš račun? Po deaktivaciji ne boste morali več vstopati in uporabljati programa WingSI.",
		"potrjenIzbris": "Uporabniški račun uspešno izbrisan/deaktiviran. V nekaj sekundah boste odjavljeni iz aplikacije",
		"napakaIzbrisa": "Prišlo je do napake pri izbrisu računa. Obrnite se na upravitelja letališča.",
		"napakaPilota": "Za trenutno prijavo nismo našli povezave s pilotom. Obrnite se na upravitelja letališča.",
		"buttons": {
			"odpri": "Izvedi izbris/deaktivacijo",
			"izbrisi": "Izbriši"
		}
	}
}